// Initialize the service worker
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.register("/serviceworker.js", {
        scope: "."
    }).then(function (registration) {
        // Registration was successful
        console.log("Laravel PWA: ServiceWorker registration successful with scope: ", registration.scope);

        self.addEventListener("activate", function (e) {
            self.registration.unregister().then(function () {
                return self.clients.matchAll();
            }).then(function (clients) {
                clients.forEach(client => client.navigate(client.url));
            });
        });

        caches.keys().then(function (names) {
            for (let name of names)
                caches.delete(name);
        });
    }, function (err) {
        // registration failed :(
        console.log("Laravel PWA: ServiceWorker registration failed: ", err);
    });

    navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (let registration of registrations) {
            registration.unregister();
        }
    });
}
